import React from "react"
import { Button, Container, Grid, Typography } from "@material-ui/core"
import { AppStyles } from "assets/styles/App"
import BlogShapeTop from "shapes/BlogShapeTop"
import BlogShapeBottom from "shapes/BlogShapeBottom"
import { graphql, Link, useStaticQuery } from "gatsby"
import ArticleBlockLink from "./ArticleBlockLink"

interface Props {}

const MyBlog: React.FC<Props> = () => {
  const classes = AppStyles()

  const data = useStaticQuery(graphql`
    query {
      allNotionPageBlog(
        filter: { isDraft: { eq: false } }
        sort: { fields: [indexPage], order: ASC }
      ) {
        edges {
          node {
            title
            slug
            excerpt
            pageIcon
            createdAt
          }
        }
      }
    }
  `)

  return (
    <Container
      maxWidth={false}
      className={`${classes.extraVerticalPadding} ${classes.myBlogOuter}`}
    >
      <Container maxWidth="md">
        <BlogShapeTop />
        <div className={classes.paddingBottom} />
        <Typography
          className={classes.heroTitle}
          variant="h2"
          align="center"
          color="textPrimary"
          gutterBottom
        >
          My Blog<span role="img">📖</span>
        </Typography>
        <Container className={classes.flexContainer} maxWidth="lg">
          <Typography
            className={classes.heroDesc}
            variant="h5"
            align="center"
            color="textPrimary"
            paragraph
          >
            I love to write about new tech mostly about front-end development. I
            wrote mostly about <strong>HTML, CSS</strong> and{" "}
            <strong>JS</strong>. Knowledge like <strong>JS</strong> framework
            also included. For me, I am more inclined to{" "}
            <strong>ReactJs</strong> library, hence most of my article are about{" "}
            <strong>ReactJs</strong>. However, I do love other framework and
            planned to learn some in the future. Usually all my article are
            written in <strong>Bahasa Melayu</strong> because I want to help{" "}
            <strong>Malaysians</strong> to understand more on web technologies
            and development.
            <Link to="/blog"> Read more...</Link>
          </Typography>
          <div className={classes.paddingBottom} />
        </Container>
        <Container
          maxWidth="md"
          className={`${classes.flexContainer} ${classes.paddingNone}`}
        >
          {data.allNotionPageBlog.edges
            .slice(0, 2)
            .map((edge: any, index: number) => (
              <ArticleBlockLink
                key={index}
                title={edge.node.title}
                link={`/blog/${edge.node.slug}`}
                excerpt={edge.node.excerpt}
                icon={edge.node.pageIcon}
                createdAt={edge.node.createdAt}
              />
            ))}
        </Container>
        <BlogShapeBottom />
      </Container>
    </Container>
  )
}

export default MyBlog
